var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "link-modal",
        centered: "",
        title: _vm.title,
        "hide-footer": "",
      },
      on: {
        close: function ($event) {
          _vm.isOpen = false
        },
      },
      model: {
        value: _vm.isOpen,
        callback: function ($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen",
      },
    },
    [
      _c(
        "div",
        { staticClass: "m-link" },
        [
          _c("copy-field", {
            attrs: { text: _vm.link },
            on: { copied: _vm.onCopy },
          }),
          _vm.success
            ? _c(
                "div",
                { staticClass: "success" },
                [
                  _c("svg-icon", {
                    staticClass: "success__icon",
                    attrs: { name: "check", color: "success", size: "14" },
                  }),
                  _vm._v(" Ссылка скопирована в буфер обмена "),
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            { staticClass: "m-link__actions" },
            [
              _c("c-button", {
                staticClass: "m-link__close",
                attrs: { label: "Закрыть" },
                on: { click: _vm.close },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }